import React from "react";
import { DataFrench } from "./DataFrench";

const French = () => {
  return (
    <div className="blockPage__content">
      {DataFrench.map((item, index) => {
        return (
          <ul key={index} className="blockPage__lists">
            <li className="blockPage__lists--item">
              <a
                className="blockPage__lists--link"
                href={item.path}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img className={item.cName} src={item.icon} alt="icon" />
                <p className="blockPage__lists--title">{item.title}</p>
              </a>
              {/* <p className="blockPage__lists--text"> {item.description} </p> */}
            </li>
          </ul>
        );
      })}
    </div>
  );
};

export default French;
